function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import Icon from '../icon';
export var UnstyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "icon-button__UnstyledButton",
  componentId: "dcmqcu-0"
})(["background-color:transparent;background-repeat:no-repeat;border:none;cursor:", ";overflow:hidden;outline:none;"], p => p.disabled ? 'auto' : 'pointer');

class IconButton extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "clickHandler", e => {
      var {
        onClick
      } = this.props;

      if (onClick) {
        onClick(e);
      }
    });
  }

  render() {
    var {
      icon,
      size,
      disabled,
      className,
      onMouseDown,
      onFocus,
      changeColorOnHoverAndActiveStates,
      forwardRef
    } = this.props;
    return /*#__PURE__*/React.createElement(UnstyledButton, {
      ref: forwardRef,
      onMouseDown: onMouseDown,
      onClick: this.clickHandler,
      onFocus: onFocus,
      disabled: disabled,
      className: className,
      type: 'button'
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      width: size,
      height: size,
      changeColorOnHoverAndActiveStates: changeColorOnHoverAndActiveStates && !disabled
    }));
  }

}

_defineProperty(IconButton, "defaultProps", {
  size: 40,
  disabled: false,
  changeColorOnHoverAndActiveStates: false
});

export default IconButton;